import { STORE_IMAGES } from '../../../../constants/urls';
import * as S from '../../Styled';
import { useMediaQuery } from '@mui/material';

const StoreCard = ({ store }) => {
    const cashback = parseFloat(store.cashbackPercentage).toFixed(1);
    const urlImageStore = `${STORE_IMAGES}${store.slug}.png`;
    const isMobile = useMediaQuery('(max-width:768px)');

    const storeLink = `https://www.meucupom.com/cupom-desconto-${store.slug}`;

    const handleClick = () => {
        window.open(storeLink, '_blank'); 
    };

    return (
        <S.CardWrapper  onClick={handleClick} >
            <S.StoreImage src={urlImageStore} alt={store.name} />
            <S.CashbackButton
                variant="contained"
                size="small"
                onClick={handleClick}
            >
                {isMobile && (
                <img
                    src="https://static.meucupom.com/media/2026%20-%20Updates/Cashback_icon-01.png"
                    alt=""
                    style={{ width: '20px', marginRight: '6px' }}
                />
                )}
                +{cashback}% de Cashback
            </S.CashbackButton>
        </S.CardWrapper>
    );
};

export default StoreCard;

